import apiClient from '@/utils/axios'

const review = {
  async postReview(lawyerId, review) {
    const response = await apiClient.post(
      '/lawyers/' + lawyerId + '/reviews',
      review,
    )
    return response
  },
}

export {review}
